import { ApiRequestError } from '@/lib/api';

import type { PushPermissionState } from './push-support';

export function createPushUnsupportedError(): ApiRequestError {
  return new ApiRequestError({
    statusCode: 400,
    code: 'PUSH_UNSUPPORTED',
    message: 'Push wird in diesem Browser nicht unterstützt.',
    timestamp: new Date().toISOString(),
    path: '/notifications/push/subscribe',
  });
}

/** Stable API surface when `PushManager` / Service Worker is unavailable. */
export type UnsupportedPushSubscriptionSnapshot = {
  supported: false;
  serverEnabled: false;
  permission: 'unsupported';
  isActiveOnThisDevice: false;
  currentEndpoint: null;
  devices: [];
  isLoading: false;
  isEnabling: false;
  isRemoving: false;
  enablePush: (permissionPromise?: Promise<NotificationPermission>) => Promise<never>;
  removeDevice: () => Promise<never>;
  refreshCurrentEndpoint: () => Promise<void>;
  enableError: null;
  removeError: null;
};

export function buildUnsupportedPushSubscriptionSnapshot(): UnsupportedPushSubscriptionSnapshot {
  const rejectUnsupported = (
    _permissionPromise?: Promise<NotificationPermission>,
  ): Promise<never> => Promise.reject(createPushUnsupportedError());

  return {
    supported: false,
    serverEnabled: false,
    permission: 'unsupported' satisfies PushPermissionState,
    isActiveOnThisDevice: false,
    currentEndpoint: null,
    devices: [],
    isLoading: false,
    isEnabling: false,
    isRemoving: false,
    enablePush: rejectUnsupported,
    removeDevice: rejectUnsupported,
    refreshCurrentEndpoint: () => Promise.resolve(),
    enableError: null,
    removeError: null,
  };
}
